import { render, staticRenderFns } from "./VerticalDotsIcon.vue?vue&type=template&id=448850f8&"
import script from "./VerticalDotsIcon.vue?vue&type=script&lang=js&"
export * from "./VerticalDotsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports